import Chart from "react-apexcharts";
import CoachMenuLayout from "../../../layouts/CoachMenuLayout";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/loader";
import { fetchCoachingDashboard } from "../../../redux/features/coach/actions/coachAction";
import { useNavigate } from "react-router-dom";
import { coachPaths } from "../../../routes/coach";

const CoachDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading2, coachingDashboardData } = useSelector(
    (state) => state.coach.coach
  );

  useEffect(() => {
    dispatch(fetchCoachingDashboard());
  }, [dispatch]);

  const options = {
    chart: {
      type: "radialBar",
      height: 250,
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: "70%",
        },
        track: {
          background: "#E8F4FB",
          strokeWidth: "100%",
        },
        dataLabels: {
          show: true,
          name: {
            show: true,
            fontSize: "14px",
            color: "#6B7280",
            offsetY: 30,
          },
          value: {
            show: true,
            fontSize: "22px",
            fontWeight: 600,
            offsetY: -10,
            formatter: (val) => `${val}%`,
          },
        },
      },
    },
    fill: {
      colors: ["#8CCDF2"],
    },
    labels: ["Active"],
  };
  const series = [0];
  const options2 = {
    chart: {
      type: "radialBar",
      height: 250,
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: "70%",
        },
        track: {
          background: "#FFEED9", // light circle color
          strokeWidth: "100%",
        },
        dataLabels: {
          show: true,
          name: {
            show: true,
            fontSize: "14px",
            color: "#6B7280",
            offsetY: 30,
          },
          value: {
            show: true,
            fontSize: "22px",
            fontWeight: 600,
            offsetY: -10,
            formatter: (val) => `${val}%`,
          },
        },
      },
    },
    fill: {
      colors: ["#FF8C00"], // orange progress
    },
    labels: ["Active"],
  };
  const series2 = [0];
  const options3 = {
    chart: {
      type: "radialBar",
      height: 250,
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: "65%",
        },
        track: {
          background: "#e6f3f9",
          strokeWidth: "100%",
        },
        dataLabels: {
          show: true,
          name: {
            show: true,
            offsetY: 30,
            color: "#6b7280",
            fontSize: "16px",
          },
          value: {
            show: true,
            fontSize: "32px",
            fontWeight: 600,
            color: "#4b5563",
            offsetY: -10,
            formatter: (val) => `${val}%`,
          },
        },
      },
    },
    fill: {
      type: "solid",
      colors: ["#00A0C6"], // main active color
    },
    stroke: {
      lineCap: "round",
    },
    labels: ["Active"],
  };
  const series3 = [0];
  const options4 = {
    chart: {
      type: "bar",
      height: 250,
    },
    plotOptions: {
      bar: {
        borderRadius: 6,
        columnWidth: "45%",
        distributed: true, // allows individual bar colors
      },
    },
    colors: [
      "#eae8f7",
      "#eae8f7",
      "#eae8f7",
      "#eae8f7",
      "#eae8f7",
      "#eae8f7",
      "#eae8f7",
      "#219EBC", // August highlighted
      "#eae8f7",
      "#eae8f7",
      "#eae8f7",
      "#eae8f7",
    ],
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      labels: {
        style: {
          colors: "#6b7280",
          fontSize: "12px",
        },
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val}%`,
      },
    },
    legend: {
      show: false,
    },
  };
  const series4 = [
    {
      name: "Growth",
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
  ];

  if (isLoading2) {
    return <Loader />;
  }

  return (
    <CoachMenuLayout>
      <div className="ct_px_40 mt-4">
        <div className="mb-4">
          <h4 className="mb-0 ct_fs_20 ct_fw_600 mb-2">Acitvity Overview</h4>
          <p className="ct_grey_text mb-0">
            Quick snapshot of your coaching activity and growth on NUVIO.
          </p>
        </div>
        <div className="row">
          <div className="col-lg-3 col-md-6 mb-4">
            <div className="ct_outline_bg h-100">
              <div className="d-flex align-items-start justify-content-between gap-2">
                <div>
                  <p className="ct_fs_14 ct_darkblue_text mb-1">Sessions</p>
                  <h4 className="ct_fs_24 ct_sky_blue_text">
                    {coachingDashboardData?.total_session || 0} booked
                  </h4>
                </div>
                <img src="/assets/img/dash_icon_1.png" alt="" />
              </div>
              <ul className="d-flex align-items-center gap-2">
                <li className="ct_fs_12 ct_orange_text">
                  <svg
                    width="23"
                    height="24"
                    viewBox="0 0 23 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1696_32114)">
                      <path
                        d="M7.03156 16.2038L15.3574 8.03125"
                        stroke="#FB8500"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                        stroke="#FB8500"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1696_32114">
                        <rect
                          width="16"
                          height="16"
                          fill="white"
                          transform="translate(11.418 0.6875) rotate(45.5323)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  0%
                </li>
                <li className="ct_text_op_2">|</li>
                <li className="ct_grey_text ct_fs_12">
                  track your coaching success
                </li>
              </ul>
              <div className="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ct_mt_16">
                <a className="ct_yellow_link ct_fs_14">View</a>
                <a>
                  <svg
                    width="14"
                    height="13"
                    viewBox="0 0 14 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.834 6.3125L1.16732 6.3125M12.834 6.3125L7.83398 11.3125M12.834 6.3125L7.83398 1.3125"
                      stroke="#FFB703"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 mb-4">
            <div className="ct_outline_bg h-100">
              <div className="d-flex align-items-start justify-content-between gap-2">
                <div>
                  <p className="ct_fs_14 ct_darkblue_text mb-1">Events Hosted</p>
                  <h4 className="ct_fs_24 ">
                    {coachingDashboardData?.total_events || 0}
                  </h4>
                </div>
                <img src="/assets/img/dash_icon_2.png" alt="" />
              </div>
              <ul className="d-flex align-items-center gap-2">
                <li className="ct_fs_12 ct_orange_text">
                  0%
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1696_32145)">
                      <path
                        d="M5.73231 8.00261L15.8359 13.8359"
                        stroke="#8ECAE6"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M9.74891 15.7105L16.1237 14.0024L14.4156 7.6276"
                        stroke="#8ECAE6"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1696_32145">
                        <rect
                          width="16"
                          height="16"
                          fill="white"
                          transform="translate(21.8555 8.07031) rotate(120)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </li>
                <li className="ct_text_op_2">|</li>
                <li className="ct_grey_text ct_fs_12">your hosted events score</li>
              </ul>
              <div className="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ct_mt_16">
                <a className="ct_dark_blue_link ct_fs_14" onClick={() => navigate(coachPaths?.Event)}>View Report</a>
                <a onClick={() => navigate(coachPaths?.Event)}>
                  <svg
                    width="14"
                    height="13"
                    viewBox="0 0 14 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.834 6.92969L1.16732 6.92969M12.834 6.92969L7.83398 11.9297M12.834 6.92969L7.83398 1.92969"
                      stroke="#023047"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 mb-4">
            <div className="ct_outline_bg h-100">
              <div className="d-flex align-items-start justify-content-between gap-2">
                <div>
                  <p className="ct_fs_14 ct_darkblue_text mb-1">
                    Total Session ( Hours ){" "}
                  </p>
                  <h4 className="ct_fs_24 ">
                    {coachingDashboardData?.total_session_hours || "0 hours"}
                  </h4>
                </div>
                <img src="/assets/img/dash_icon_3.png" alt="" />
              </div>
              <ul className="d-flex align-items-center gap-2">
                <li className="ct_fs_12 ct_orange_text">
                  <svg
                    width="23"
                    height="24"
                    viewBox="0 0 23 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1696_32114)">
                      <path
                        d="M7.03156 16.2038L15.3574 8.03125"
                        stroke="#FB8500"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                        stroke="#FB8500"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1696_32114">
                        <rect
                          width="16"
                          height="16"
                          fill="white"
                          transform="translate(11.418 0.6875) rotate(45.5323)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  0%
                </li>
                <li className="ct_text_op_2">|</li>
                <li className="ct_grey_text ct_fs_12">Growth Playbook</li>
              </ul>
              <div className="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ct_mt_16">
                <a className="ct_dark_blue_link ct_fs_14">View Report</a>
                <a>
                  <svg
                    width="14"
                    height="13"
                    viewBox="0 0 14 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.834 6.92969L1.16732 6.92969M12.834 6.92969L7.83398 11.9297M12.834 6.92969L7.83398 1.92969"
                      stroke="#023047"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 mb-4">
            <div className="ct_outline_bg h-100">
              <div className="d-flex align-items-start justify-content-between gap-2">
                <div>
                  <p className="ct_fs_14 ct_darkblue_text mb-1">Outstanding </p>
                  <h4 className="ct_fs_24 ">
                    $ {coachingDashboardData?.total_outstanding || 0}
                  </h4>
                </div>
                <img src="/assets/img/dash_icon_4.png" alt="" />
              </div>
              <ul className="d-flex align-items-center gap-2">
                <li className="ct_fs_12 ct_darksky_blue_text">
                  <svg
                    width="23"
                    height="24"
                    viewBox="0 0 23 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1696_32198)">
                      <path
                        d="M7.03156 16.2038L15.3574 8.03125"
                        stroke="#219EBC"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                        stroke="#219EBC"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1696_32198">
                        <rect
                          width="16"
                          height="16"
                          fill="white"
                          transform="translate(11.418 0.6875) rotate(45.5323)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  0%
                </li>
                <li className="ct_text_op_2">|</li>
                <li className="ct_grey_text ct_fs_12">
                  Track income trends and milestones.
                </li>
              </ul>
              <div className="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ct_mt_16">
                <a className="ct_dark_blue_link ct_fs_14">View Report</a>
                <a>
                  <svg
                    width="14"
                    height="13"
                    viewBox="0 0 14 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.834 6.92969L1.16732 6.92969M12.834 6.92969L7.83398 11.9297M12.834 6.92969L7.83398 1.92969"
                      stroke="#023047"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xxl-5 col-xl-5 mb-4">
            <div className="ct_outline_bg h-100">
              <div className="d-flex align-items-center justify-content-between gap-2">
                <div>
                  <h4 className="ct_fs_20">Activity</h4>
                  <p className="ct_text_clr_acacac">Platform report</p>
                </div>
                <div
                  className="position-relative"
                  style={{ minWidth: "98px" }}
                >
                  <select
                    className="form-control ct_input ct_border_radius_10"
                    style={{
                      height: "46px",
                      paddingRight: "36px",
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                      backgroundImage: "none",
                    }}
                  >
                    <option value="">Monthly</option>
                  </select>
                  <i
                    className="fa-solid fa-angle-down ct_pointer_events_none"
                    style={{
                      position: "absolute",
                      right: "14px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#023047",
                      fontSize: "14px",
                    }}
                  ></i>
                </div>
              </div>
              <Chart
                options={options4}
                series={series4}
                type="bar"
                height={250}
              />
            </div>
          </div>
          <div className="col-xxl-5 col-xl-4 mb-4">
            <div className="ct_outline_bg h-100">
              <h4 className="ct_fs_20 mb-3">Shortcut</h4>
              <ul className="ct_shortcut_list">
                <li>
                  <div>
                    <p className=" ct_fs_12 mb-1">View Upcoming Sessions</p>
                    <ul>
                      <li className="ct_fs_14 ct_text_clr_757886">
                        {coachingDashboardData?.total_session || 0} reservation
                      </li>
                      <li>
                        <span className="ct_dot_5"></span>
                      </li>
                      <li className="ct_fs_14">Review Panel</li>
                    </ul>
                  </div>
                  <a className="text-dark">
                    <i className="fa-solid fa-arrow-right"></i>
                  </a>
                </li>
                <li className="ct_border_top_light ct_mt_16 ct_pt_16">
                  <div>
                    <p className="ct_text_clr_757886 mb-1">Manage Events</p>
                    <ul>
                      <li className="ct_fs_14 ct_text_clr_757886">
                        {coachingDashboardData?.total_events || 0} Hosted{" "}
                      </li>
                      <li>
                        <span className="ct_dot_5"></span>
                      </li>
                      <li className="ct_fs_14">Events Panel</li>
                    </ul>
                  </div>
                  <a className="text-dark">
                    <i className="fa-solid fa-arrow-right"></i>
                  </a>
                </li>
                <li className="ct_border_top_light ct_mt_16 ct_pt_16">
                  <div>
                    <p className="ct_text_clr_757886 mb-1">Upload eBooks</p>
                    <ul>
                      <li className="ct_fs_14 ct_text_clr_757886">
                        {Number(coachingDashboardData?.workshops || 0) +
                          Number(coachingDashboardData?.webinars || 0)}{" "}
                        items
                      </li>
                      <li>
                        <span className="ct_dot_5"></span>
                      </li>
                      <li className="ct_fs_14">Resource Library</li>
                    </ul>
                  </div>
                  <a className="text-dark">
                    <i className="fa-solid fa-arrow-right"></i>
                  </a>
                </li>
                <li className="ct_border_top_light ct_mt_16 ct_pt_16">
                  <div>
                    <p className="ct_text_clr_757886 mb-1">View Earnings</p>
                    <ul>
                      <li className="ct_fs_14 ct_text_clr_757886">
                        ${coachingDashboardData?.total_outstanding || 0}
                      </li>
                      <li>
                        <span className="ct_dot_5"></span>
                      </li>
                      <li className="ct_fs_14">Earnings Report</li>
                    </ul>
                  </div>
                  <a className="text-dark">
                    <i className="fa-solid fa-arrow-right"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-xxl-2 col-xl-3 mb-4">
            <div className="ct_outline_bg h-100">
              <ul>
                <li className="ct_yellow_card">
                  <div className="d-flex align-items-center gap-3 mb-2">
                    <img src="/assets/img/outgoing-call_1.png" alt="" />
                    <h6 className="mb-0 ct_fs_20">Discovery Call</h6>
                  </div>
                  <div className="text-end">
                    <a className="ct_white_link">Book Now</a>
                  </div>
                </li>
                <li className="ct_sky_blue_card mt-4">
                  <div className="d-flex align-items-center gap-3 mb-2">
                    <img src="/assets/img/diamond_284894_1.png" alt="" />
                    <h6 className="mb-0 ct_fs_20 text-white">Momentum </h6>
                  </div>
                  <div className="text-end">
                    <a className="ct_sky_blue_text ct_white_link">Upgrade Now</a>
                  </div>
                </li>
                <li className="ct_light_sky_card mt-4">
                  <div className="d-flex align-items-center gap-3 mb-2">
                    <img src="/assets/img/pngegg_8_1.png" alt="" />
                    <h6 className="mb-0 ct_fs_20">Coach Rating </h6>
                  </div>
                  <div className="text-end">
                    <i className="fa-solid fa-star ct_yellow_text"></i>
                    <i className="fa-solid fa-star ct_yellow_text"></i>
                    <i className="fa-solid fa-star ct_yellow_text"></i>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          {/* <div className="col-xxl-4 mb-4">
            <div className="ct_outline_bg h-100">
              <div className="d-flex align-items-center gap-3 mb-4">
                <img
                  src="/assets/img/Upcoming_calneder_icon.png"
                  alt=""
                  className="ct_flex_shrink_0"
                />
                <h4 className="mb-0 ct_fs_20">Upcoming appointments</h4>
              </div>
              <ul>
                <li className="d-flex align-items-center justify-content-between gap-2">
                  <div className="d-flex align-items-center gap-3">
                    <h6 className="mb-0 text-center">
                      JAN <br />
                      31
                    </h6>
                    <div>
                      <p className="ct_orange_text mb-1">
                        Coaching session Follow Up{" "}
                      </p>
                      <ul className="d-flex align-items-center gap-2">
                        <li className="ct_text_clr_757886 ct_fs_12">
                          Today at 10:54 AM{" "}
                        </li>
                        <li>
                          <span className="ct_dot_5"></span>
                        </li>
                        <li className="ct_darksky_blue_text ct_fs_12">Confirmed</li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <a className="text-dark">
                      <i className="fa-solid fa-arrow-right"></i>
                    </a>
                  </div>
                </li>
                <li className="d-flex align-items-center justify-content-between gap-2 pt-4">
                  <div className="d-flex align-items-center gap-3">
                    <h6 className="mb-0 text-center">
                      Feb <br />7
                    </h6>
                    <div>
                      <p className="ct_yellow_text mb-1">Clarity 1st session </p>
                      <ul className="d-flex align-items-center gap-2">
                        <li className="ct_text_clr_757886 ct_fs_12">
                          {" "}
                          7th February 2026 at 10:54 AM{" "}
                        </li>
                        <li>
                          <span className="ct_dot_5"></span>
                        </li>
                        <li className="ct_orange_text ct_fs_12">Pending</li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <a className="text-dark">
                      <i className="fa-solid fa-arrow-right"></i>
                    </a>
                  </div>
                </li>
                <li className="d-flex align-items-center justify-content-between gap-2 pt-4">
                  <div className="d-flex align-items-center gap-3">
                    <h6 className="mb-0 text-center">
                      Feb <br />
                      17
                    </h6>
                    <div>
                      <p className="ct_sky_blue_text mb-1">Deep Dive session 2 </p>
                      <ul className="d-flex align-items-center gap-2">
                        <li className="ct_text_clr_757886 ct_fs_12">
                          {" "}
                          17th February 2026 at 10:54 AM{" "}
                        </li>
                        <li>
                          <span className="ct_dot_5"></span>
                        </li>
                        <li className="ct_darksky_blue_text ct_fs_12">Confirmed</li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <a className="text-dark">
                      <i className="fa-solid fa-arrow-right"></i>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div> */}
          <div className="col-xxl-8 mb-4">
            <div className="row">
              <div className="col-xl-4 mb-4 col-lg-4">
                <div className="ct_outline_bg h-100">
                  <h4 className="ct_fs_20 ct_fw_600 ct_darksky_blue_text">
                    Sessions
                  </h4>
                  <Chart
                    options={options3}
                    series={series3}
                    type="radialBar"
                    height={250}
                  />
                  <div className="session-stats">
                    <div className="d-flex align-items-start">
                      <span className="booked-dot"></span>
                      <div>
                        <h6 className="ct_fs_24 mb-1">0</h6>
                        <p className="mb-0 ct_grey_text">Booked</p>
                      </div>
                    </div>
                    <div className="d-flex align-items-start">
                      <span className="completed-dot"></span>
                      <div>
                        <h6 className="ct_fs_24 mb-1">0</h6>
                        <p className="mb-0 ct_grey_text">Completed</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 mb-4 col-lg-4">
                <div className="ct_outline_bg h-100">
                  <h4 className="ct_fs_20 ct_fw_600 ct_orange_text">
                    New prospects{" "}
                  </h4>
                  <Chart
                    options={options2}
                    series={series2}
                    type="radialBar"
                    height={250}
                  />
                  <div className="session-stats">
                    <div className="d-flex align-items-start">
                      <span
                        className="booked-dot"
                        style={{ backgroundColor: "#FB8500" }}
                      ></span>
                      <div>
                        <h6 className="ct_fs_24 mb-1">0</h6>
                        <p className="mb-0 ct_grey_text">Active</p>
                      </div>
                    </div>
                    <div className="d-flex align-items-start">
                      <span
                        className="completed-dot"
                        style={{
                          backgroundColor: "hwb(31.79deg 0% 1.57% / 19%)",
                        }}
                      ></span>
                      <div>
                        <h6 className="ct_fs_24 mb-1">0</h6>
                        <p className="mb-0 ct_grey_text">Inactive</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 mb-4 col-lg-4">
                <div className="ct_outline_bg h-100">
                  <h4 className="ct_fs_20 ct_fw_600 ct_sky_blue_text">Events </h4>
                  <Chart
                    options={options}
                    series={series}
                    type="radialBar"
                    height={250}
                  />
                  <div className="session-stats">
                    <div className="d-flex align-items-start">
                      <span
                        className="booked-dot"
                        style={{ backgroundColor: "#8ECAE6" }}
                      ></span>
                      <div>
                        <h6 className="ct_fs_24 mb-1">0</h6>
                        <p className="mb-0 ct_grey_text">Active</p>
                      </div>
                    </div>
                    <div className="d-flex align-items-start">
                      <span
                        className="completed-dot"
                        style={{
                          backgroundColor: "hsl(199.09deg 63.77% 72.94% / 21%)",
                        }}
                      ></span>
                      <div>
                        <h6 className="ct_fs_24 mb-1">0</h6>
                        <p className="mb-0 ct_grey_text">Inactive</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CoachMenuLayout>
  );
};

export default CoachDashboard;

